const modal = document.querySelector('#global-modal');
const overlay = document.querySelector('.lav-modal__overlay');
const closeButton = modal.querySelector('.lav-modal__close');
const content = modal.querySelector('.lav-modal__content');

const closeModal = () => {
  modal.classList.remove('lav-modal__is-open');
  content.innerHTML = '';
};

overlay.addEventListener('click', closeModal);
closeButton.addEventListener('click', closeModal);

document.querySelectorAll('[data-has-tooltip]').forEach((el) => {
  const button = document.createElement('button');
  button.classList.add('tooltip-button');
  button.setAttribute('type', 'button');

  const svg = document.createElement('svg');
  svg.classList.add('icon');
  button.appendChild(svg);

  const use = document.createElement('use');
  use.setAttribute('href', '#circle-question');
  svg.appendChild(use);

  el.appendChild(button);

  button.addEventListener('click', () => {
    const heading = document.createElement('h2');
    const paragraph = document.createElement('p');

    heading.innerHTML = JSON.parse(
      el.getAttribute('data-tooltip-heading')
    ).replace(/(?:\r\n|\r|\n)/g, '<br>');
    paragraph.innerHTML = JSON.parse(
      el.getAttribute('data-tooltip-content')
    ).replace(/(?:\r\n|\r|\n)/g, '<br>');

    content.appendChild(heading);
    content.appendChild(paragraph);

    modal.classList.add('lav-modal__is-open');
  });
});
